import { Actions, ActionValue } from './Actions.model';
import { Role } from './Roles.model';

const { Timetable, Student, Feedback, Notification } = Actions;

export const Permissions: Record<Role, ActionValue[]> = {
  [Role.GLOBAL_ADMIN]: [
    Timetable.Read.All,
    Timetable.Write.All,
    Student.Read.All,
    Student.Write.All,
    Feedback.Write.Self,
    Notification.Read.All,
    Notification.Read.Self,
    Notification.Write.All,
    Notification.Write.Self,
  ],
  [Role.TIMETABLE_ADMIN]: [
    Timetable.Read.All,
    Timetable.Write.All,
    Student.Read.All,
    Student.Write.All,
    Feedback.Write.Self,
  ],
  [Role.TIMETABLE_MANAGER]: [
    Timetable.Read.All,
    Student.Read.All,
    Feedback.Write.Self,
  ],
  [Role.NOTIFICATION_ADMIN]: [
    Notification.Read.All,
    Notification.Read.Self,
    Notification.Write.All,
    Notification.Write.Self,
  ],
  [Role.FEEDBACK_USER]: [Feedback.Write.Self],
};
